import React from "react";
import { Tween } from "react-gsap";
// import { TimelineMax, Linear } from "gsap";

const TweenSvgWrapper = props => {
    return (
        <Tween
            wrapper={
                <svg
                    width="72px"
                    height="72px"
                    viewBox="0 0 72 72"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    className={props.className}
                />
            }
            from={{
                svgDraw: 0
            }}
            to={{
                svgDraw: 1
            }}
        >
            {props.children}
        </Tween>
    );
};
export const SVGSuccessIcon = props => {
    return (
        <TweenSvgWrapper {...props}>
            <path
                d="M36,71 C55.3299663,71 71,55.3299663 71,36 C71,16.6700337 55.3299663,1 36,1 C16.6700337,1 1,16.6700337 1,36 C1,55.3299663 16.6700337,71 36,71 Z"
                id="oval-3"
                stroke="#0000FF"
                strokeWidth="2"
                fill="none"
            ></path>
            <polyline
                id="tick"
                stroke="#0000FF"
                strokeWidth="2"
                strokeLinecap="round"
                fillRule="nonzero"
                fillOpacity="0"
                points="17.9743301 35.7695486 31.6752238 48.9881583 54.9009946 23.0958425"
            ></polyline>
        </TweenSvgWrapper>
    );
};
export const SVGWarningIcon = props => {
    return (
        <TweenSvgWrapper {...props}>
            <path
                d="M36,71 C55.3299663,71 71,55.3299663 71,36 C71,16.6700337 55.3299663,1 36,1 C16.6700337,1 1,16.6700337 1,36 C1,55.3299663 16.6700337,71 36,71 Z"
                id="oval-2"
                stroke="#161616"
                strokeWidth="2"
                fill="none"
            ></path>
            <clipPath id="exclamation-clip">
                <polygon
                    id="exclamation-line"
                    points="34.390625 40.953125 34 28.625 34 24 37.078125 24 37.078125 28.625 36.703125 40.953125"
                ></polygon>
            </clipPath>
            <path
                clipPath="url(#exclamation-clip)"
                d="M35.5,24 L35.5,40.95"
                id="line"
                stroke="#161616"
                strokeWidth="3"
            ></path>
            <path
                d="M35.5,44 L35.5,47.08"
                id="dot"
                stroke="#161616"
                strokeWidth="3"
            ></path>
        </TweenSvgWrapper>
    );
};
export const SVGInfoIcon = props => {
    return (
        <TweenSvgWrapper {...props}>
            <path
                d="M36,71 C55.3299663,71 71,55.3299663 71,36 C71,16.6700337 55.3299663,1 36,1 C16.6700337,1 1,16.6700337 1,36 C1,55.3299663 16.6700337,71 36,71 Z"
                id="oval-3"
                stroke="#0000FF"
                strokeWidth="2"
                fill="none"
            ></path>
            <path
                id="info-dot"
                d="M1.5,0 L1.5,3"
                transform="translate(35.000000, 25.000000)"
                stroke="#0000FF"
                strokeWidth="3"
            ></path>
            <path
                id="info-body"
                d="M1.31171162,7 L1.98380798,22 L1.01965966,22 L1.31171162,7 Z"
                transform="translate(35.000000, 25.000000)"
                stroke="#0000FF"
                strokeWidth="2"
            ></path>
        </TweenSvgWrapper>
    );
};
export const SVGDeclineIcon = () => {
    return (
        <TweenSvgWrapper>
            <path
                d="M36,71 C55.3299663,71 71,55.3299663 71,36 C71,16.6700337 55.3299663,1 36,1 C16.6700337,1 1,16.6700337 1,36 C1,55.3299663 16.6700337,71 36,71 Z"
                id="oval-3"
                stroke="#B20000"
                strokeWidth="2"
                fill="none"
            ></path>
            <line
                x1="30.3492424"
                y1="15.8064827"
                x2="0.650757595"
                y2="15.8064827"
                id="x1"
                stroke="#B20000"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                transform="translate(35.500000, 36.000000) rotate(-45.000000) translate(-35.500000, -36.000000) translate(20.000000, 20.000000)"
            ></line>
            <line
                x1="15.6935173"
                y1="30.8492424"
                x2="15.6935173"
                y2="1.1507576"
                id="x2"
                stroke="#B20000"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                transform="translate(35.500000, 36.000000) rotate(-45.000000) translate(-35.500000, -36.000000) translate(20.000000, 20.000000)"
            ></line>
        </TweenSvgWrapper>
    );
};

export const SVGTimeOutIcon = () => {
    return (
        <TweenSvgWrapper>

            <path
                d="M36,71 C55.3299663,71 71,55.3299663 71,36 C71,16.6700337 55.3299663,1 36,1 C16.6700337,1 1,16.6700337 1,36 C1,55.3299663 16.6700337,71 36,71 Z"
                id="oval-3"
                stroke="#0000FF"
                strokeWidth="2"
                fill="none"
            ></path>
                <path d="M44.1132812,24.625 L42.4882812,24.625 L42.4882812,30.0839844 C42.4882812,31.4043035 42.1201209,32.5764923 41.3837891,33.6005859 C40.6474573,34.6246796 39.5006588,35.5260378 37.9433594,36.3046875 C39.5514403,37.1171916 40.7151657,38.0481718 41.4345703,39.0976562 C42.153975,40.1471407 42.5136719,41.4081958 42.5136719,42.8808594 C42.5136719,43.8457079 42.5094401,44.717444 42.5009766,45.4960938 C42.492513,46.2747435 42.4882812,46.8841124 42.4882812,47.3242188 L44.1132812,47.3242188 C44.3333344,47.3242188 44.5237622,47.4046216 44.6845703,47.5654297 C44.8453784,47.7262378 44.9257812,47.9166656 44.9257812,48.1367188 C44.9257812,48.3736991 44.8453784,48.5683586 44.6845703,48.7207031 C44.5237622,48.8730476 44.3333344,48.9492188 44.1132812,48.9492188 L27.8125,48.9492188 C27.5924468,48.9492188 27.402019,48.8730476 27.2412109,48.7207031 C27.0804028,48.5683586 27,48.3736991 27,48.1367188 C27,47.9166656 27.0804028,47.7262378 27.2412109,47.5654297 C27.402019,47.4046216 27.5924468,47.3242188 27.8125,47.3242188 L29.4882812,47.3242188 C29.4882812,46.8841124 29.4840495,46.2747435 29.4755859,45.4960938 C29.4671224,44.717444 29.4628906,43.8457079 29.4628906,42.8808594 C29.4628906,41.4081958 29.8183558,40.1471407 30.5292969,39.0976562 C31.2402379,38.0481718 32.3912681,37.1171916 33.9824219,36.3046875 C32.4589768,35.5260378 31.3291052,34.6246796 30.5927734,33.6005859 C29.8564416,32.5764923 29.4882812,31.4043035 29.4882812,30.0839844 L29.4882812,24.625 L27.8125,24.625 C27.5924468,24.625 27.402019,24.5445972 27.2412109,24.3837891 C27.0804028,24.222981 27,24.0325532 27,23.8125 C27,23.5755196 27.0804028,23.3808601 27.2412109,23.2285156 C27.402019,23.0761711 27.5924468,23 27.8125,23 L44.1132812,23 C44.3333344,23 44.5237622,23.0761711 44.6845703,23.2285156 C44.8453784,23.3808601 44.9257812,23.5755196 44.9257812,23.8125 C44.9257812,24.0325532 44.8453784,24.222981 44.6845703,24.3837891 C44.5237622,24.5445972 44.3333344,24.625 44.1132812,24.625 Z M31.0878906,42.8808594 C31.0878906,43.8626351 31.0921224,44.7386029 31.1005859,45.5087891 C31.1090495,46.2789752 31.1132812,46.8841124 31.1132812,47.3242188 L40.8632812,47.3242188 C40.8632812,46.8841124 40.867513,46.2747435 40.8759766,45.4960938 C40.8844401,44.717444 40.8886719,43.8457079 40.8886719,42.8808594 C40.8886719,41.7636663 40.575524,40.7480514 39.9492188,39.8339844 C39.3229135,38.9199173 37.9941508,38.0397178 35.9628906,37.1933594 C33.9316305,38.0397178 32.6113312,38.9199173 32.0019531,39.8339844 C31.3925751,40.7480514 31.0878906,41.7636663 31.0878906,42.8808594 Z M40.8632812,24.625 L31.1132812,24.625 L31.1132812,30.0839844 C31.1132812,30.8626341 31.3841119,31.7259067 31.9257812,32.6738281 C32.4674506,33.6217495 33.8131403,34.5442663 35.9628906,35.4414062 C38.1295681,34.5442663 39.487953,33.6217495 40.0380859,32.6738281 C40.5882189,31.7259067 40.8632812,30.8626341 40.8632812,30.0839844 L40.8632812,24.625 Z" id="" fill="#0000FF" fillRule="nonzero"></path>
                <path d="M41.4560907,44 C41.6034002,44 41.7308776,44.1979147 41.8385269,44.59375 C41.9461762,44.9895853 42,45.4583306 42,46 C42,46.5833362 41.9461762,47.0624981 41.8385269,47.4375 C41.7308776,47.8125019 41.6034002,48 41.4560907,48 L30.5439093,48 C30.3965998,48 30.2691224,47.8125019 30.1614731,47.4375 C30.0538238,47.0624981 30,46.5833362 30,46 C30,45.4583306 30.0538238,44.9895853 30.1614731,44.59375 C30.2691224,44.1979147 30.3965998,44 30.5439093,44 L41.4560907,44 Z" id="-copy-2" fill="#0000FF" fillRule="nonzero"></path>
        </TweenSvgWrapper>
    );
};
